import React, { Component } from 'react';

import legislator_success from '../images/legislator_success.jpg';
import fake_news from '../images/fake_news.jpg';
import non_policy from '../images/non_policy.jpg'

import { Icon } from 'semantic-ui-react';

class Books extends Component {

    constructor(props) {
        super(props);
        this.refOne = React.createRef();
        this.refTwo = React.createRef();
        this.refThree = React.createRef();
      }

    sharpenAnimationOne(e) {
        this.refOne.current.style.opacity = '1.0';
    }

    dullAnimationOne(e) {
        this.refOne.current.style.opacity = '0.8';
    }

    sharpenAnimationTwo(e) {
        this.refTwo.current.style.opacity = '1.0';
    }

    dullAnimationTwo(e) {
        this.refTwo.current.style.opacity = '0.8';
    }

    sharpenAnimationThree(e) {
        this.refThree.current.style.opacity = '1.0';
    }

    dullAnimationThree(e) {
        this.refThree.current.style.opacity = '0.8';
    }


    render() {
        return (
            <React.Fragment>
                <div style={horizontalDivider} />
                <div style={booksOverallWrapperStyle}>
                    <div style={booksStyle}>
                        <div style={booksSubStyle}>
                            <h1 style={booksHeaderStyle}>Featured Books</h1>

                            <div style={booksWrapperStyle}>
                                <div style={individualBookStyle}>
                                    <a href="https://www.amazon.com/Legislator-Success-Fragmented-Congresses-Argentina-ebook/dp/B00IO0ECSE/ref=sr_1_1?dchild=1&keywords=legislator+success+in+fragmented+congresses+in+argentina&qid=1599965984&s=digital-text&sr=1-1" target="_blank" onMouseEnter={this.sharpenAnimationOne.bind(this)} onMouseLeave={this.dullAnimationOne.bind(this)}>
                                    <img src={legislator_success} alt='Legislator Success' style={bookImageStyle} ref={this.refOne} />
                                    <div style={bookCaptionStyle}>
                                        <p style={bookCaptionTextStyle}>Legislator Success in Fragmented Congresses in Argentina<Icon name='angle right'/></p>
                                        
                                    </div> 
                                    </a>
                                </div>
                                
                                <div style={individualBookStyle}>
                                    <a href="https://www.amazon.com/gp/product/B086HQKSX4/ref=dbs_a_def_rwt_bibl_vppi_i1" target="_blank"  onMouseEnter={this.sharpenAnimationTwo.bind(this)} onMouseLeave={this.dullAnimationTwo.bind(this)}>
                                    <img src={fake_news} alt='Fake News' style={bookImageStyleBordered} ref={this.refTwo} />
                                    <div style={bookCaptionStyle}>
                                        <p style={bookCaptionTextStyle}>Fake News, Trolls, y Otros Encantos<Icon name='angle right'/></p>
                                    </div> 
                                    </a>
                                </div>

                                <div style={individualBookStyle}>
                                    <a href="https://www.amazon.com/gp/product/B07N49GCCT/ref=dbs_a_def_rwt_bibl_vppi_i2" target="_blank" onMouseEnter={this.sharpenAnimationThree.bind(this)} onMouseLeave={this.dullAnimationThree.bind(this)}>
                                    <img src={non_policy} alt='Legislator Success' style={bookImageStyle} ref={this.refThree}/>
                                    <div style={bookCaptionStyle}>
                                        <p style={bookCaptionTextStyle}>Non-Policy Politics<Icon name='angle right'/></p>
                                    </div> 
                                    </a>
                                </div>
                            </div>

                        </div>  
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const horizontalDivider = {
    width: '530px',
    height: '2px',
    margin: '10px auto',
    backgroundColor: '#e8e8e8',
}

const booksOverallWrapperStyle = {
    width: '100%',
    padding: '60px 20px 20px 20px',
}

const booksStyle = {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
}

const booksSubStyle = {
    width: '1200px',
    margin: '0px 0px 0px 0px',
    textAlign: 'center',
    order: '3',
}

const booksHeaderStyle = {
    fontFamily: 'Heebo, sans-serif',
    fontSize: '40px',
    fontWeight: '300',
    padding: '10px 20px 40px 19px'
}

const booksWrapperStyle = {
    display: 'flex',
    flexFlow: 'row wrap',
}

const individualBookStyle = {
    height: '530px',
    width: '280px',
    display: 'flex',
    flexFlow: 'column nowrap',
    margin: '0px 40px 0px 40px',
}

const bookImageStyle = {
    height: '400px',
    opacity: '0.8',
    transition: 'opacity .2s',
}

const bookImageStyleBordered = {
    height: '400px',
    opacity: '0.8',
    transition: 'opacity .2s',
    border: '1px solid black'
}

const bookCaptionStyle = {
    width: '266px',
    padding: '14px 0px 0px 12px',
    fontFamily: 'Source Serif Pro, sans-serif',
    fontSize: '22px',
    textAlign: 'left'
    
}

const bookCaptionTextStyle = {
    
}

export default Books;